import React from "react";

/**
 * Vagalume official logo (PNG). Renders the full brand mark.
 */
export function Logo({ size = 56, className = "" }) {
  return (
    <img
      src="/vagalume-logo.png"
      alt="Vagalume — Find your Soul"
      style={{
        height: size,
        width: "auto",
        maxHeight: size,
        objectFit: "contain",
        filter: "drop-shadow(0 0 12px hsl(var(--primary) / 0.25))",
      }}
      className={className}
      data-testid="logo-mark"
    />
  );
}

/**
 * Hero-sized rendering: uses the full PNG (firefly + VAGALUME + FIND YOUR SOUL).
 */
export function LogoHero({ size = 260, className = "" }) {
  return (
    <img
      src="/vagalume-logo.png"
      alt="Vagalume — Find your Soul"
      width={size}
      style={{
        width: size,
        height: "auto",
        maxWidth: "100%",
        filter: "drop-shadow(0 0 32px hsl(var(--primary) / 0.35))",
      }}
      className={className}
      data-testid="logo-hero"
    />
  );
}
